import { EngagementProductListWithUser } from '@epicuro-next/data/engagement/engagement-models';
import { List, Media } from '@epicuro-next/models/engagement';
import { createAction, props } from '@ngrx/store';

import { IUpdateListWithProducts } from '../../models';

export const updateProductList = createAction(
  '[ProductList] Update List with media',
  props<{
    list: Partial<List> & Pick<List, 'id' | 'name'>;
    media?: Partial<Media> | null;
    skipRedirectionToList?: boolean;
  }>(),
);

export const updateProductListSuccess = createAction(
  '[ProductList] Update List Success',
  props<{
    list: EngagementProductListWithUser;
    isEditedByOtherAdminWithPermission?: boolean;
    skipRedirectionToList?: boolean;
  }>(),
);

export const updateCommercialListSuccess = createAction(
  '[ProductList] Update Commercial List Success',
  props<{
    list: List;
    isEditedByOtherAdminWithPermission?: boolean;
    skipRedirectionToList?: boolean;
  }>(),
);

export const updateProductListFailed = createAction(
  '[ProductList] Update List Failed',
  props<{ error: string }>(),
);

export const updateProductListWithProducts = createAction(
  '[ProductList] Update List with media and products',
  props<IUpdateListWithProducts>(),
);
